// extracted by mini-css-extract-plugin
export default {"borderedContainer":"ReorderSnapshot-module__borderedContainer---Nkz-","embedContainer":"ReorderSnapshot-module__embedContainer--KkMXY"};